import React                           from 'react';
import { withRouter }                  from 'react-router';
import { connect }                     from 'react-redux';
import { ClipLoader }                  from 'react-spinners';
import { Accordion }                   from 'react-bootstrap';
import { EmployeeOnboardingConstants } from '../environment';
import { removeFetchData,
         removeDisplayFetchData }      from '../../../../actions/employee-onboarding/remove';

var apiHost = EmployeeOnboardingConstants.WebApiHost;
var error   = 'There was an error processing your request.';

class Remove extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reason   : '',
      rid      : 0,
      notes    : ''
    };
    
    this.removeId = this.removeId.bind(this);
    this.submit   = this.submit.bind(this);
  }
  
  removeId() {
    var query  = new URLSearchParams(this.props.location.search);
    var remove = query.get('remove_id');
    return remove;
  }
  
  updateNotes(event) {
    this.setState({ notes: event.target.value });
  }

  updateReason(event) {
    this.setState({ reason: event.target.options[event.target.selectedIndex].text, rid: event.target.value });
  }
  
  submit() {
    var remove = this.removeId();
    var json   = {
      remove_id: encodeURIComponent(remove),
      reason:    this.state.reason,
      rid:       this.state.rid, 
      notes:     this.state.notes  
    };
    
    if (this.state.rid > 0) {
      this.props.fetchDataRemove(apiHost, json);
    }
  }

  componentDidMount() {
    var remove = this.removeId();
    this.props.fetchDataRemoveDisplay(apiHost, remove);
  }

  render() {
    return (
      <div>
        <div style={{ marginRight: 'auto', marginLeft: 'auto', width: '5em' }}>
          { this.props.removeIsLoading ?
            <ClipLoader
              color={'#072659'}
              loading={this.props.removeIsLoading}
            />
            : <span />
          }
          { this.props.removeDisplayIsLoading ?
            <ClipLoader
              color={'#072659'}
              loading={this.props.removeDisplayIsLoading}
            />
            : <span />
          }
        </div>
        { this.props.removeDisplayHasErrored || this.props.removeHasErrored ?
          <Accordion className='well-red'>
            {error}
          </Accordion>
          : <span />
       }
       { !this.props.removeDisplayHasErrored && !this.props.removeDisplayIsLoading && !this.props.removeDisplay.update ?
          <Accordion className='well-red'>
            {this.props.removeDisplay.message}
          </Accordion>
          : <span />
       }
       { !this.props.removeIsLoading && !this.props.removeDisplayIsLoading && this.props.remove.update &&
         !this.props.removeHasErrored && !this.props.removeDisplayHasErrored ?
          <Accordion>
            Successfully removed <b>{this.props.removeDisplay.userFriendly}</b> from <b>{this.props.removeDisplay.groupFriendly}</b>
          </Accordion>
          : <span />
       }
       { this.props.removeDisplay.update && !this.props.remove.update && !this.props.removeIsLoading && 
         !this.props.removeDisplayIsLoading && !this.props.removeHasErrored && !this.props.removeDisplayHasErrored ?
         <div>
           <Accordion>
             Please take a moment and let us know why <strong>{this.props.removeDisplay.userFriendly}</strong> is being removed from <strong>{this.props.removeDisplay.groupFriendly}</strong>.
           </Accordion>
           <div className='block'>
             <label>
               Reason* &nbsp;
               <select selected={0} onChange={evt => this.updateReason(evt)} style={{fontWeight: 'normal'}}>
                 <option value={0}></option> 
                 <option value={1}>Don't need it anymore</option> 
                 <option value={2}>Left university</option> 
                 <option value={3}>Switched jobs within department</option> 
                 <option value={4}>Changed department</option> 
                 <option value={5}>Student no longer enrolled in relevant class/program</option> 
                 <option value={6}>Other</option> 
               </select>
             </label>
             <div className='block'>
               <label>
                 <b>Notes &nbsp;</b>
                 <textarea onChange={evt => this.updateNotes(evt)} style={{fontWeight: 'normal'}} rows='4' cols='50' />
               </label>
             </div>
             <div style={{clear: 'both'}} className='block'>
               <button className="c-btn c-btn--sm" onClick={this.submit}>
                 <span className="c-btn__text">Submit</span>
               </button>
             </div>
           </div>
         </div>
        : <span />
       }
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    remove: state.employee.remove.remove,
    removeHasErrored: state.employee.remove.removeHasErrored,
    removeIsLoading: state.employee.remove.removeIsLoading,
    removeDisplay: state.employee.remove.removeDisplay,
    removeDisplayHasErrored: state.employee.remove.removeDisplayHasErrored,
    removeDisplayIsLoading: state.employee.remove.removeDisplayIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDataRemove:        (host, params) => dispatch(removeFetchData(host, params)),
    fetchDataRemoveDisplay: (host, remove) => dispatch(removeDisplayFetchData(host, remove))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Remove));
